// extracted by mini-css-extract-plugin
export var base = "_2e-0";
export var updateBanner = "_2e-1";